// src/components/LogoutButton.js
import React from "react";
import { useNavigate } from "react-router-dom";

function LogoutButton() {
  const navigate = useNavigate();

  const handleLogout = () => {
    localStorage.removeItem("admin_logged_in"); // اطلاعات لاگین رو پاک کن
    navigate("/login"); // به صفحه لاگین برو
  };

  return (
    <button className="btn-glass btn-glass-danger" onClick={handleLogout}>
      🚪 خروج
    </button>
  );
}

export default LogoutButton;
